import React from 'react';
import TableCasino from '../../../../../@casino/ui/table';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useDispatch, useSelector } from 'react-redux';
import { setGetGamerList } from '../../store/thunk/setGetGamerList';
import {getDate} from '../../../../../@casino/lib/getDate';

const useStyles = makeStyles(() => ({
    search: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        borderRadius: 4,
        color: '#fff',
        outline: 'none',
        margin: '10px 0',
        width: '97.3%'
    }
}));

const Gamer = ({groups}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [search, setSearch] = React.useState('');

    React.useEffect(() => {
        dispatch(setGetGamerList({
            groups,
            page: 1,
            rowsPerPage: 10,
            search: ''
        }))
    }, [groups]);

    const users  = useSelector(state => state.groups.gamer);

    const rowsHistory = (history) => {
        return  history.map((item) => {
            return {
                id: item.id,
                login: item.login,
                date_event: getDate(+item.registration),
                balance: new Intl.NumberFormat('ru-RU').format(item.balance) + '₽',
                air_balance: new Intl.NumberFormat('ru-RU').format(item.air_balance) + '₽',
                sum_deposit: new Intl.NumberFormat('ru-RU').format(item.sum_deposit) + '₽',
                sum_withdrawal: new Intl.NumberFormat('ru-RU').format(item.sum_withdrawals) + '₽',
                difference: item.sum_deposit - item.sum_withdrawals,
            }
        })
    } 
    

    const columns = [
        { id: 'id', label: 'ID'},
        { id: 'login', label: 'Логин'},
        { id: 'date_event', label: 'Дата регистрации'},
        { id: 'balance', label: 'Баланс'},
        { id: 'air_balance', label: 'Воздушный баланс'},
        { id: 'sum_deposit', label: 'Сумма пополнений'},
        { id: 'sum_withdrawal', label: 'Сумма выводов'},
        { id: 'difference', label: 'Разница'}
    ]

    const rows = rowsHistory(users.list);

    return (
        <div style={{
            width: 'calc(100% - 40px)',     
            background: '#1b2039',
            borderRadius: '8px',
            padding: 20,
            marginTop: 12,
        }}>
            <span style={{
                color: '#fff',

            }}>Игроки</span>
            <div style={{height: 1, background: 'rgb(176, 176, 176)', marginTop: 12}}>

            </div>
            <input 
                type="text"
                placeholder="Поиск"
                className={classes.search}
                value={search}
                onChange={(v) => {
                    dispatch(setGetGamerList({
                        groups,
                        page: 1,
                        rowsPerPage: 10,
                        search: v.target.value
                    }))
                    setSearch(v.target.value);
                }}
            />
            {/*  */}
            <TableCasino 
                pagination
                allPage={users.count}
                width={1300}
                perPage={10}
                columns={columns}
                rows={rows}
                changePage={(v) => dispatch(setGetGamerList({
                    groups,
                    page: +v.page + 1,
                    rowsPerPage: v.rowsPerPage,
                    search
                }))}
                changeRowsPerPage={(v) => dispatch(setGetGamerList({
                    groups,
                    page: +v.page + 1,
                    rowsPerPage: v.rowsPerPage,
                    search
                }))}
                route="/gamer/list/"
            />
        </div>
    )
}

export default Gamer;